// extracted by mini-css-extract-plugin
export default {"iconContainer":"IconButton_iconContainer__38w7N","iconSmall":"IconButton_iconSmall__3UABt","iconLarge":"IconButton_iconLarge__SS4KQ"};